export default __webpack_public_path__ + "static/media/NIAS0210.34I-32805_-17918_0.45264e6b.jpg";